import { Component, Input } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { FuncionesService } from '../../comun/services/funciones.service';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-paseo-detalles',
  templateUrl: './paseo-detalles.component.html',
  styleUrl: './paseo-detalles.component.css'
})
export class PaseoDetallesComponent {
  @Input() slug!: number;
  misdatos: any = {};
  paseo: any = {};
  busy: number = 0;
  loading: boolean = false;

  constructor(private query: QueryService, private funciones: FuncionesService) { 
    this.loading = true;
  }

  ngOnInit() {
    this.getMisDatos();
  }
  
  getMisDatos() {
    this.busy++;
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {      
      this.misdatos = resultado;
      this.busy--;
      this.getPaseo();
    });
  }

  getPaseo() {
    this.busy++;
    this.query.query('paseos', 'GET', { pa_id: this.slug }).subscribe((resultado:any) => {      
      this.paseo = resultado.registros[0];
      this.busy--;
      this.loading = false;
    });
  }

  participar() {
    this.busy++;
    this.query.query('paseos', 'PARTICIPAR', { pa_id: this.paseo.pa_id, participante: this.paseo.participante }).subscribe((resultado:any) => {      
      this.busy--;
      this.getPaseo();
    });
  }

  goPerfil(perfil: any) {
    window.open(GlobalConstants.urlServer + 'perfil/' + perfil.slug, '_blank');
  }

  verEnMapa() {
    //https://www.google.es/maps/place/C.+San+Miguel,+32,+38001+Santa+Cruz+de+Tenerife/
    let direccion = this.funciones.replaceSpacesWithPlus(this.paseo.pa_ubicacion);
    window.open('https://www.google.es/maps/place/' + direccion, '_blank');
  }

}
